// react
import React from 'react';
import styled from 'styled-components';

// radix
import * as RadixLabel from '@radix-ui/react-label';

/**
 * Label is a small header for form components.
 */
export const Label = ({
  className,
  id,
  text,
  isRequired,
  ...props
}: LabelProps) => {
  return (
    <StyledLabelRoot className={className} htmlFor={id} {...props}>
      {text}
      <StyledIsRequired>{isRequired && '*'}</StyledIsRequired>
    </StyledLabelRoot>
  );
};

const StyledLabelRoot = styled(RadixLabel.Root)`
  // default styles
  display: flex;
  color: ${(props) => props.theme.color.neutral[90]};
  font: ${(props) => props.theme.typography.body.md.medium};
`;

const StyledIsRequired = styled.span`
  margin-left: ${(props) => props.theme.spacing[2]};
  color: ${(props) => props.theme.color.danger[60]};
`;

export interface LabelProps {
  className?: string;
  id: string;
  text: string;
  isRequired?: boolean;
}

Label.componentName = 'Label';

export default Label;
